import React from 'react';

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../shared';

export const AnalysisRequestScheduleReportModal = ({ props, showModal, setShowModal, onScheduleConfirmation, modalHeader, modalBodyLabel, size = 'm' }) => {

    // const { className } = props;

    const onAccept = () => {
        setShowModal(false);
        onScheduleConfirmation();
    }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-2'
                onClick={onAccept}
                label='Aceptar'
                outline={true}
                icon="mdi mdi-checkbox-marked-circle me-1"
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={() => setShowModal(false)}
                label='Cancelar'
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    const title = (
        <div className="d-flex align-items-center ms-3 p-0">
            <span className="mdi mdi-alert-outline mdi-36px text-warning ps-4 m-0"></span>
            <label className="m-0 p-0">
                <h4 className="text-primary m-0 ps-2">{modalHeader}</h4>
            </label>
        </div>
    );

    return (
        <BaseCustomModal
            title={title}
            isModalOpen={showModal}
            handleCancel={() => setShowModal(false)}
            centered
            zIndex={9999}
            width="40%" 
            footer={buttons}
        >
            <GradientDecorationLine />

            <div className="px-4">
                <h5 className="text-primary">{modalBodyLabel}</h5>
            </div>

            <GradientDecorationLine />
        </BaseCustomModal>
    )
}
